/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement Generator
 * Generator für AORV-Angebote
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractAssignedMachineGroup
 */
export interface ContractAssignedMachineGroup {
    /**
     * 
     * @type {string}
     * @memberof ContractAssignedMachineGroup
     */
    machineGroupId: string;
    /**
     * 
     * @type {number}
     * @memberof ContractAssignedMachineGroup
     */
    manPower: number;
}

/**
 * Check if a given object implements the ContractAssignedMachineGroup interface.
 */
export function instanceOfContractAssignedMachineGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "machineGroupId" in value;
    isInstance = isInstance && "manPower" in value;

    return isInstance;
}

export function ContractAssignedMachineGroupFromJSON(json: any): ContractAssignedMachineGroup {
    return ContractAssignedMachineGroupFromJSONTyped(json, false);
}

export function ContractAssignedMachineGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractAssignedMachineGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machineGroupId': json['machineGroupId'],
        'manPower': json['manPower'],
    };
}

export function ContractAssignedMachineGroupToJSON(value?: ContractAssignedMachineGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineGroupId': value.machineGroupId,
        'manPower': value.manPower,
    };
}

